import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <path
          d="m 26.162348,59.85793 v -32.304 q 2.304,-0.528 4.896,-0.672 a 103.57,103.57 0 0 1 2.158,-0.098 q 0.987,-0.034 1.872,-0.043 a 59.917,59.917 0 0 1 0.578,-0.003 30.782,30.782 0 0 1 4.47,0.312 24.562,24.562 0 0 1 3.162,0.672 16.8,16.8 0 0 1 3.847,1.609 14.464,14.464 0 0 1 2.081,1.463 13.651,13.651 0 0 1 3.599,4.788 16.031,16.031 0 0 1 0.217,0.492 q 1.255,2.98 1.338,7.027 a 28.23,28.23 0 0 1 0.006,0.581 23.478,23.478 0 0 1 -0.257,3.564 q -0.308,2.001 -0.983,3.694 a 14.44,14.44 0 0 1 -0.104,0.254 14.43,14.43 0 0 1 -2.911,4.472 13.744,13.744 0 0 1 -0.905,0.856 15.277,15.277 0 0 1 -4.427,2.644 18.477,18.477 0 0 1 -1.525,0.524 24.797,24.797 0 0 1 -4.61,0.884 31.349,31.349 0 0 1 -3.094,0.148 57.837,57.837 0 0 1 -2.006,-0.037 q -1.052,-0.036 -2.218,-0.109 a 95.827,95.827 0 0 1 -0.336,-0.022 q -2.544,-0.168 -4.848,-0.696 z m 6.048,-27.744 v 23.232 a 13.677,13.677 0 0 0 0.363,0.028 q 0.421,0.027 0.991,0.043 a 43.665,43.665 0 0 0 0.038,10e-4 q 0.662,0.019 1.689,0.023 a 158.515,158.515 0 0 0 0.663,10e-4 19.064,19.064 0 0 0 3.427,-0.287 q 3.583,-0.656 5.669,-2.809 2.828,-2.918 2.99,-8.033 a 19.896,19.896 0 0 0 0.01,-0.631 17.544,17.544 0 0 0 -0.308,-3.395 q -0.391,-1.979 -1.277,-3.511 a 9.116,9.116 0 0 0 -1.343,-1.782 8.996,8.996 0 0 0 -3.521,-2.195 q -1.441,-0.512 -3.218,-0.707 a 21.328,21.328 0 0 0 -2.333,-0.122 q -2.026,0 -3.18,0.082 a 12.568,12.568 0 0 0 -0.66,0.062 z"
          fill="currentColor"
        />
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
